module.exports = __webpack_public_path__ + "img/DealerIcons-DataAcquisition-On.3795245.jpg";